import React from "react";

interface SectionCardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  actions,
  children,
  className,
}) => (
  <section className={`rounded-md border border-cardborder bg-white ${className ?? ""}`}>
    {(title || actions || description) && (
      <header className="flex flex-col gap-3 border-b border-cardborder px-5 py-4 md:flex-row md:items-center md:justify-between">
        <div>
          {title && <h2 className="text-base font-semibold text-gray-900">{title}</h2>}
          {description && <p className="mt-1 text-xs text-gray-500">{description}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
      </header>
    )}
    <div className="px-5 py-4">{children}</div>
  </section>
);
